/* <recently-viewed> — localStorage'da son 8 ürün handle'ı; /products/<handle>.js ile çizer, boşsa gizli kalır. */
if (!customElements.get('recently-viewed')) {
  const KEY = 'cpl:recently-viewed';
  const MAX = 8;

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* depolama kapalı */
    }
  };

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const current = this.dataset.current;
      const limit = parseInt(this.dataset.limit, 10) || 6;
      const handles = read().filter((h) => h !== current).slice(0, limit);
      if (current) write([current].concat(read().filter((h) => h !== current)));
      if (handles.length) this.render(handles);
    }

    async render(handles) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const results = await Promise.all(
        handles.map((h) =>
          fetch(`${root}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      // Silinmiş ürünleri listeden temizle
      const missing = handles.filter((h, i) => !results[i]);
      if (missing.length) write(read().filter((h) => !missing.includes(h)));

      const products = results.filter(Boolean);
      const list = this.querySelector('[data-rv-list]');
      const tpl = this.querySelector('[data-rv-template]');
      if (!products.length || !list || !tpl) return;

      products.forEach((p) => {
        const li = tpl.content.firstElementChild.cloneNode(true);
        li.querySelector('a').href = p.url;
        const img = li.querySelector('img');
        const src = p.featured_image;
        if (src) {
          const url = src.startsWith('//') ? `https:${src}` : src;
          img.src = url + (url.includes('?') ? '&' : '?') + 'width=128';
        } else {
          img.remove();
        }
        li.querySelector('.rv-card__name').textContent = p.title;
        li.querySelector('.rv-card__sub').textContent = p.type || p.vendor || '';
        li.querySelector('.rv-card__price').textContent = CPL.formatMoney(p.price);
        list.appendChild(li);
      });
      this.hidden = false;
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
}
